<template>
  <div :class="$style.layout">
    <splashscreen-maintenance v-if="shouldShowMaintenance" />
    <template v-else>
      <sidebar-primary-inbuilt v-if="$matchMedia.up('sm')" />

      <template v-if="$matchMedia.down('sm')">
        <app-header
          icon-left="menu"
          @click-icon-left="isPrimaryDrawerActive = true"
          @click-icon-right="navigateTo('/m')"
        />
        <sidebar-primary-drawer v-model="isPrimaryDrawerActive" />
      </template>

      <main :class="$style.main">
        <slot />
      </main>

      <app-drawer />
      <sidebar-secondary-inbuilt v-if="$matchMedia.up('sm')" />
    </template>
  </div>
</template>

<script lang="ts" setup>
import SplashscreenMaintenance from '~/components/splashscreen/maintenance/index.vue'
import SidebarPrimaryInbuilt from '~/components/layout/app/sidebar-primary/inbuilt.vue'
import AppHeader from '~/components/layout/app/header/index.vue'
import SidebarPrimaryDrawer from '~/components/layout/app/sidebar-primary/drawer.vue'
import AppDrawer from '~/components/layout/app/drawer/index.vue'
import SidebarSecondaryInbuilt from '~/components/layout/app/sidebar-secondary/inbuilt.vue'
import { useAccountStore } from '~/stores/account'

const runtimeConfig = useRuntimeConfig()
const accountStore = useAccountStore()

const isTester = computed(() => accountStore.hasScope('accessTesting'))
const shouldShowMaintenance = computed(
  () => runtimeConfig.public.isMaintenance && !isTester.value
)

const isPrimaryDrawerActive = ref(false)
</script>

<style lang="scss" module>
.layout {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;

  @include down(sm) {
    flex-direction: column;
  }
}

:root {
  @include down(sm) {
    --layout-app-gap: 1em;
  }
}

.main {
  margin: 0
    calc(var(--layout-app-sidebar-secondary-width) + var(--layout-app-gap)) 0
    var(--layout-app-sidebar-primary-width);
  flex: 1 1 0;
  min-width: 0;

  @include down(sm) {
    margin: 0;
    padding-bottom: env(safe-area-inset-bottom, 3.2em);
  }
}
</style>
